export const listDateToTimeOnMarket = (listDate: string) => {
  const date1: Date = new Date();
  const date2: Date = new Date(listDate);
  const timeInMilisec: number = date1.getTime() - date2.getTime();
  const daysOnMarket: number = Math.floor(timeInMilisec / (1000 * 60 * 60 * 24));

  if (daysOnMarket === 0) {
    return { value: '', description: 'Listed Today', shortDescription: 'Today' };
  } else if (daysOnMarket === 1) {
    return { value: daysOnMarket, description: ' Day On Market', shortDescription: 'Day' };
  } else {
    return { value: daysOnMarket, description: ' Days On Market', shortDescription: 'Days' };
  }
};